import { render, staticRenderFns } from "./orderPageAddrMsg.vue?vue&type=template&id=ffd7eb5e&scoped=true"
import script from "./orderPageAddrMsg.vue?vue&type=script&lang=js"
export * from "./orderPageAddrMsg.vue?vue&type=script&lang=js"
import style0 from "./orderPageAddrMsg.vue?vue&type=style&index=0&id=ffd7eb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd7eb5e",
  null
  
)

export default component.exports